export default __webpack_public_path__ + "static/media/ITU.8442aad7.svg";